"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RangePickerContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
exports.RangePickerContext = react_1.default.createContext({});
//# sourceMappingURL=RangePickerContext.js.map